import { Draggable } from '@hello-pangea/dnd';
import { Card } from '../../Atoms/Card';
import { SrOnlyText, Text } from '../../Atoms/Text';
import { Toggle } from '../../Atoms/Toggle';
import { ChangeEventHandler, ReactNode } from 'react';

export interface DraggableCardProps {
  draggableId: string;
  index: number;
  label: string;
  checked: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
  actionElement?: ReactNode;
  badge?: ReactNode;
  cardClassName?: string;
  enableCardShadow?: boolean;
  useDefaultCardStyles?: boolean;
}

export function DraggableCard({
  draggableId,
  index,
  label,
  checked,
  onChange,
  actionElement,
  badge,
  cardClassName = 'flex items-center bg-white p-3 my-0 mb-4',
  enableCardShadow = true,
  useDefaultCardStyles = true
}: DraggableCardProps) {
  return (
    <Draggable
      draggableId={draggableId}
      index={index}>
      {(provided) => (
        <div
          {...provided.draggableProps}
          ref={provided.innerRef}>
          <Card
            className={cardClassName}
            enableShadow={enableCardShadow}
            useDefaultCardStyles={useDefaultCardStyles}>
            <span
              {...provided.dragHandleProps}
              className="drag-button p-2 mr-3">
              <SrOnlyText>drag icon</SrOnlyText>
            </span>
            <label className="flex grow items-center">
              <Text
                size="sm"
                dataTestId={label}>
                {label}
              </Text>
              {badge}
              {actionElement || (
                <Toggle
                  id={draggableId}
                  className="ml-auto float-right mr-[5px] inline-block"
                  checked={checked}
                  onChange={onChange}
                  dataTestId={label}
                />
              )}
            </label>
          </Card>
        </div>
      )}
    </Draggable>
  );
}
